import styled from 'styled-components';

export const Container = styled.div`
  padding: 0 70px;
  flex: 1;
`;
